import DashboardLayout from "../components/layouts/DashboardLayout/DashboardLayout";

export default function PaymentsPage() {

    return (

        <DashboardLayout
            pageTitle="Mon Profil"
        >

            <div style={{ padding: "30px" }}>

                <h1>Mes informations </h1>

                <p>

                    Cette page sera développée prochainement.

                </p>

            </div>

        </DashboardLayout>

    );

}